
import './Title.scss';

type Props = {
    title? : string 
}

const Title = ({title=''}:Props): JSX.Element => {
    return (
        <div className="nav-title">
            <span>{title}</span>
        </div>
    );
}

export default Title;
